import { omit } from '@styled-system/props';
import { InputHTMLAttributes, ReactNode, Ref, forwardRef } from 'react';
import { createComponent, createHook } from 'reakit-system';
import { Box, BoxOptions } from '../Box/Box';
import { cx, ecss } from '../reexports/emotion';
import { CheckablesWrapper } from '../hooks/checkables/CheckablesWrapper';

function RadioIcon() {
  return (
    <Box
      className="icon"
      borderRadius="round"
      borderWidth="1"
      size="checkableSize"
      aria-hidden="true"
      position="relative"
    />
  );
}

// eslint-disable-next-line @typescript-eslint/ban-types -- здесь нам нужно any, не равное undefined или null
const useRadioInput = createHook<{}, InputHTMLAttributes<HTMLInputElement>>({
  name: 'RadioInput',
  useProps(options, props) {
    return {
      ...props,
      className: cx(
        props.className,
        ecss({
          label: 'Radiobutton',
          opacity: 0,
          zIndex: -1,
          width: 1,
          height: 1,
          overflow: 'hidden',
          position: 'absolute',
        })
      ),
    };
  },
});

const Input = createComponent({
  as: 'input',
  useHook: useRadioInput,
  memo: true,
});

type Props = {
  hasError?: boolean;
  label?: ReactNode;
  hint?: ReactNode;
} & InputHTMLAttributes<HTMLInputElement> &
  BoxOptions;

export const Radio = forwardRef(function Radio(
  { hasError, disabled, label, hint, width, ...props }: Props,
  ref: Ref<HTMLInputElement>
) {
  const inputProps: InputHTMLAttributes<HTMLInputElement> = omit(props);

  return (
    <CheckablesWrapper
      width={width}
      hasError={hasError}
      disabled={disabled}
      inputType="Radiobutton"
      label={label}
      hint={hint}
    >
      <Input type="radio" {...inputProps} ref={ref} disabled={disabled} />
      <RadioIcon />
    </CheckablesWrapper>
  );
});

export type RadioProps = Props;
